/**
 * 首页接口
 */
import request from '../request'

const URL = {
  /**
      * 首页顶部轮播
      */
  indexPageSwiperList: '/advertisement/findBannerListByReceive', // 获得首页顶部轮播
  oldTimeForToday: '/memorabilia/findOneIndex', // 获得历史上的今天
  goodCourseList: '/course/findListOfSeriesForIndex', // 首页精选课程
  vrSceneMsgList: '/vrScene/findOneForIndex', // 首页vr专区
  modelList: '/libModel/findPageForVrSpecial', // 模型专区
  allViewList: '/vrPanorama/findOneForIndex', // 全景专区
  fiveGMsg: '/thirdPartyCooperater/findListByReceive', // 5g专题信息
  socketapiVr: '/socketapi/pushP2pU3d', // 单播发送消息(头盔)
  changTongCode: '/org/findPageBySelf', // 昌通码
  // seriesList: '/series/findList', // 系列列表（建党、建军、建国）
  seriesList: '/series/findListForH5', // 系列列表（建党、建军、建国）

}
const news = {
  /**
     * 首页
     */
  // 顶部轮播
  getIndexPageSwiperList (reqData) {
    return request.put(URL.indexPageSwiperList, reqData)
  },
  // 历史上的今天
  getOldTimeForToday (reqData) {
    return request.get(URL.oldTimeForToday, reqData)
  },
  // 首页精选课程
  getGoodCourseList (id) {
    return request.get(URL.goodCourseList + '/' + id)
  },
  // 首页vr专区
  getVrSceneMsgList (reqData) {
    return request.get(URL.vrSceneMsgList, reqData)
  },
  // 模型专区
  getModelList (reqData) {
    return request.put(URL.modelList, reqData)
  },
  // 全景专区
  getAllViewList (reqData) {
    return request.get(URL.allViewList, reqData)
  },
  // 5g专题信息
  get5GMsg (reqData) {
    return request.put(URL.fiveGMsg, reqData)
  },
  // 单播发送消息(头盔)
  getSocketapiVr (reqData) {
    return request.post(URL.socketapiVr, reqData)
  },
  // 获得昌通码
  getChangTongCode (reqData) {
    return request.put(URL.changTongCode, reqData)
  },
  // 系列列表（建党、建军、建国）
  getSeriesList (reqData) {
    return request.put(URL.seriesList, reqData)
  },

}
export default news
